import { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { TicketDataGridCols } from "./data-grid-cols";
import { DataTable } from "../../../components/data-table";
import { LookupService } from "../../../app/core/lookup.service";
import Offcanvas from 'react-bootstrap/Offcanvas';

export const Tickets = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [ticketsData, setTicketsData] = useState<any>();
  const [inputValue, setInputValue] = useState("");
  const [fromDate, setFromDate] = useState<any>();
  const [toDate, setToDate] = useState<any>();
  const [show, setShow] = useState(false);
  const [resolved, setResolved] = useState<any>();
  const initialPayload = {
    limit: 10,
    page: 0,
    ...(params.org && {buId : params.org})
  }
  const [pageCount, setPageCount] = useState<any>(initialPayload);

  const handleCloseModal = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    loadTickets(initialPayload);
  }, []);

  const loadTickets = async (data: any) => {
    setLoading(true);
    try {
      const featureGroups = await LookupService.getTicketsInfo(data);
      setLoading(false);
      featureGroups.results.forEach((el: any) => {
        el.created_dt = moment(el?.created_dt).format("DD-MM-YYYY");
        el.view = (
          <button
            className="px-5 py-1 rounded primary-bg text-white border-0"
            onClick={() => getTicketData(el)}
          >
            View
          </button>
        );
        el.ticket_status = el.resolved === 1 ? <div className="text-success fw-bold">Resolved</div> : <div className="text-danger fw-bold">Not Resolved</div>
      });
      setTicketsData(featureGroups);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onSelectPaginator = (data: any) => {
    const pageData = pageCount;
    pageData.page = data;
    setPageCount(pageData);
    loadTickets(pageCount);
  };


  const getTicketData = (data: any) => {
    if(params.org){
      navigate(`/dashboard/organizations/org-details/${params.org}/ticket/${data?._id}`)
    }
    else{
    navigate(`/dashboard/tickets/${data?._id}`);
    }
  };

  const handleChange = (e: any) => {
    let payload = { limit: 10, page: 0, search: e.target.value, DateFrom: fromDate, DateTo: toDate, resolved: resolved, ...(params.org && {buId : params.org})};
    loadTickets(payload);
    setInputValue(e.target.value);
  }

  const searchData = () => {
    let payload = { limit: 10, page: 0, search: inputValue, DateFrom: fromDate, DateTo: toDate, resolved: resolved, ...(params.org && {buId : params.org}) };
    setPageCount(payload);
    loadTickets(payload);
  }

  const handleClose = () => {
    setInputValue("");
    setFromDate("");
    setToDate("");
    setPageCount(initialPayload);
    loadTickets(initialPayload);
    setResolved("");
  }


  const selectFromDate = (e: any) => {
    setFromDate(e.target.value);
  }

  const selectToDate = (e: any) => {
    setToDate(e.target.value)
  }

  const onChangeValues = (e: any) => {
    setResolved(e.target.value);
  }

  const applyFilter = () => {
    let payload = { limit: 10, page: 0, search: inputValue, DateFrom: fromDate, DateTo: toDate, resolved: resolved,...(params.org && {buId : params.org}) };
    setPageCount(payload);
    loadTickets(payload);
    handleCloseModal();
  }



  return (
    <div className="container-fluid content-bg-color">
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12 text-end d-flex justify-content-between pl-8 align-items">
              <h4 className="primary-color fw-bold mt-3">Tickets</h4>
            </div>
            <div className="d-flex ps-0"><input type="text" className="form-control" value={inputValue} onChange={handleChange} placeholder="Search ..." /><i className="bi bi-funnel-fill px-2 border border-secondary-subtle rounded cursor-pointer ms-1" style={{ fontSize: '20px' }} onClick={handleShow}></i></div>
            <div className="row mt-2">
              <div className="col-md-5 mb-2 ps-0">
                <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
              </div>
              <div className="col-md-5 mb-2">
                <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
              </div>
              <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={searchData}>Search</button></div>
              <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={handleClose}>Clear</button></div>
            </div>
          </div>
          <div className="row ">
            <div className="col-12 px-0">
              {loading && (
                <div className="text-center p-5">
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                </div>
              )}
              {!loading && (
                <>
                  <DataTable
                    tableData={ticketsData}
                    TableCols={TicketDataGridCols}
                    pagination={true}
                    pageCount={pageCount}
                    onSelectPageChange={(e) => onSelectPaginator(e)}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Offcanvas show={show} onHide={handleCloseModal} placement="end">
        <Offcanvas.Header closeButton className="pb-0">
          <Offcanvas.Title className="pb-0">Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <h6>Status</h6>
          <select className="form-select" aria-label="Small select example" value={resolved} onChange={(e) => onChangeValues(e)}>
            <option selected value="">Select one option</option>
            <option value="1">Resolved</option>
            <option value="0">Not Resolved</option>
          </select>
          {resolved?.length > 0 && <div className="text-center my-2"><button className="px-3 border-1 rounded primary-color border-primary bg-white" onClick={()=>applyFilter()}>Apply Filter</button></div>}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};
